import Login from '../pages/login'
import Home from '../pages/home'
import { Breadcrumb } from 'antd';
import Template from '../pages/template'
import TemplateFree from '../pages/template/free'
import TemplateWWWW from '../pages/template/www'
import Tutor from '../pages/template/tutor'
import Hello from '../pages/config/hello'
import Channel from '../pages/config/channel'
import Article from '../pages/article'
import ArticleCreate from '../pages/article/create'
import Writing from '../pages/writing'
import WritingCreate from '../pages/writing/create'
import ClientUser from '../pages/client_user'

import LlmChannel from '../pages/llm/channel'
import LlmChannelCreate from '../pages/llm/channel_create'
import LlmDispatch from '../pages/llm/dispatch'
import LlmAgentList from '../pages/llm/agent_list'
import LlmAgentEdit from '../pages/llm/agent_edit'

import { AppstoreAddOutlined, HomeOutlined } from '@ant-design/icons';

const style = {
    margin: '16px 0',
}

const cv = {
    "/": {
        icon: <HomeOutlined />,
        component: <Home />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>主页</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/template": {
        icon: <AppstoreAddOutlined />
    },
    "/template/list": {
        component: <Template />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>提示词模板</Breadcrumb.Item>
            <Breadcrumb.Item>列表</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/template/list/free": {
        component: <TemplateFree />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>提示词模板</Breadcrumb.Item>
            <Breadcrumb.Item>画板模式</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/template/list/www": {
        component: <TemplateWWWW />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>提示词模板</Breadcrumb.Item>
            <Breadcrumb.Item>搜索模式</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/template/tutor": {
        component: <Tutor />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>提示词模板</Breadcrumb.Item>
            <Breadcrumb.Item>Tutor</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/config": {
        icon: <AppstoreAddOutlined />
    },
    "/config/hello": {
        component: <Hello />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>配置管理</Breadcrumb.Item>
            <Breadcrumb.Item>AI打招呼</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/config/channel": {
        component: <Channel />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>配置管理</Breadcrumb.Item>
            <Breadcrumb.Item>YouTube频道</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/article": {
        icon: <AppstoreAddOutlined />
    },
    "/user": {
        icon: <AppstoreAddOutlined />
    },
    "/user/list": {
        component: <ClientUser />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>用户管理</Breadcrumb.Item>
            <Breadcrumb.Item>用户列表</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/article/list": {
        component: <Article />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>文章管理</Breadcrumb.Item>
            <Breadcrumb.Item>文章列表</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/article/create": {
        component: <ArticleCreate />,
        layout: true,
        hideMenu: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>文章管理</Breadcrumb.Item>
            <Breadcrumb.Item>新建文章</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/writing": {
        icon: <AppstoreAddOutlined />
    },
    "/writing/list": {
        component: <Writing />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>写作任务管理</Breadcrumb.Item>
            <Breadcrumb.Item>写作任务列表</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/writing/create": {
        component: <WritingCreate />,
        layout: true,
        hideMenu: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>写作任务管理</Breadcrumb.Item>
            <Breadcrumb.Item>新建写作任务</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/llm": {
        icon: <AppstoreAddOutlined />
    },
    "/llm/channel": {
        component: <LlmChannel />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>大模型管理</Breadcrumb.Item>
            <Breadcrumb.Item>大模型渠道</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/llm/channel/create": {
        component: <LlmChannelCreate />,
        layout: true,
        hideMenu: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>大模型管理</Breadcrumb.Item>
            <Breadcrumb.Item>新建大模型渠道</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/llm/diapatch": {
        component: <LlmDispatch />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>大模型管理</Breadcrumb.Item>
            <Breadcrumb.Item>大模型调度</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/llm/workflow": {
        component: <LlmAgentList />,
        layout: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>大模型管理</Breadcrumb.Item>
            <Breadcrumb.Item>大模型Agent</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/llm/workflow/edit": {
        component: <LlmAgentEdit />,
        layout: true,
        hideMenu: true,
        breadcrumb: <Breadcrumb style={style}>
            <Breadcrumb.Item>大模型管理</Breadcrumb.Item>
            <Breadcrumb.Item>大模型Agent编辑</Breadcrumb.Item>
        </Breadcrumb>
    },
    "/login": {
        component: <Login />,
        layout: false
    }
}

export default cv